/**
 * Lo que la sección «Campañas de invitados» calcula, fuera del render para poder probarlo.
 */

/** Porcentaje de cupo usado (verificados / tope), acotado a 0–100. */
export function porcentajeCupo(campana) {
  if (!campana?.tope) return 0
  return Math.min(100, Math.round((campana.verificados / campana.tope) * 100))
}

/** Un registro ya existe: el código va impreso en el QR y no se cambia. */
export function codigoBloqueado(campana) {
  return !!campana && (campana.verificados + campana.pendientes) > 0
}

/**
 * ISO del API → valor de `<input type="datetime-local">` en la hora local del navegador.
 * `new Date(iso)` sí sirve aquí: el ISO trae zona horaria (no es una fecha suelta como en MiPlan).
 */
export function aInputLocal(iso) {
  if (!iso) return ''
  const d = new Date(iso)
  const dos = (n) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${dos(d.getMonth() + 1)}-${dos(d.getDate())}T${dos(d.getHours())}:${dos(d.getMinutes())}`
}

/** Valor de `datetime-local` → ISO para el API; vacío es `null` (sin fecha). */
export function deInputLocal(valor) {
  return valor ? new Date(valor).toISOString() : null
}

/** Lo que se manda al crear o editar. El código va en minúsculas, como lo guarda el backend. */
export function datosCampana(form) {
  return {
    codigo: String(form.codigo || '').trim().toLowerCase(),
    nombre: String(form.nombre || '').trim(),
    paquete: form.paquete ? Number(form.paquete) : null,
    tope: Number(form.tope),
    activa: !!form.activa,
    inicio: deInputLocal(form.inicio),
    fin: deInputLocal(form.fin),
  }
}
